var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof formtoolm !== "undefined") return resolve();
	__webpack_require__.l("${ENV_APP_FORM_TOOL_M_HOST}?timeStr=1715952171196", function(event) {
		if(typeof formtoolm !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "formtoolm");
}).then(function() { return formtoolm; });